var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"filters-header",on:{"click":function($event){_vm.$emit('click')}}},[_c('span',{staticClass:"filters-header__content"},[_vm._v("\n    Filtruj lokalizacje "),(_vm.count)?_c('span',[_vm._v("("+_vm._s(_vm.count)+")")]):_vm._e()])])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-103c3bb6","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/containers/Settings/FiltersHeader.vue
// module id = null
// module chunks = 